import React from "react";
import PanToolIcon from "@mui/icons-material/PanTool";
import { helpAgeLabel } from "./medtrackRow";
import "./Bell.css";

// Room tablet "Call for help" on a MedTrack tile (TSK-8074): a pulsing amber strip across the top
// of the tile (over the appointment time / token; patient, provider and room name stay visible) -
// hand icon, "HELP REQUESTED" and the time since the request ("4 min ago") - plus an amber ring
// around the tile (helpTileStyle). Separate from the wait-time bell (provider-coloured ringing bell) and
// from care's red URGENT banner (emergency_alert). Same amber as care's Waiting Room help badge.
export const HELP_AMBER = "#B45309";

export const helpTileStyle = (helpRequest) =>
  helpRequest ? { boxShadow: `0 0 0 4px ${HELP_AMBER}, 0 0 18px 4px rgba(245, 158, 11, 0.55)` } : {};

// compact: a pill (the header list of requests whose patient is on no tile), with the room.
const HelpRequestBadge = ({ helpRequest, compact = false, room = "" }) => {
  if (!helpRequest) return null;
  const age = helpAgeLabel(helpRequest.minutes);
  const ago = age === "just now" ? age : `${age} ago`;
  const common = {
    "data-testid": "medtrack-help-badge",
    role: "status",
    "aria-label": `Help requested${room ? ` in room ${room}` : ""}, ${ago}`,
    title: `Help requested ${ago}`,
    style: { background: HELP_AMBER },
  };
  if (compact) {
    return (
      <div {...common} className="help-badge-pulse flex items-center gap-1 rounded-full px-3 py-0.5 text-sm font-extrabold uppercase text-white whitespace-nowrap">
        <PanToolIcon style={{ fontSize: 16 }} />
        <span>Help requested</span>
        {room ? <span className="normal-case">· Room {room}</span> : null}
        <span className="font-bold normal-case" data-testid="medtrack-help-age">· {age}</span>
      </div>
    );
  }
  // Tile: a 33px strip over the tile's time / token row (patient, provider and room stay visible).
  return (
    <div {...common} className="help-badge-pulse absolute left-0 right-0 top-0 z-20 flex h-[33px] items-center gap-1.5 px-3 text-white">
      <PanToolIcon style={{ fontSize: 22 }} />
      <div className="flex flex-col gap-[2px] leading-none whitespace-nowrap">
        <span className="text-[14px] font-extrabold uppercase tracking-wide">Help requested</span>
        <span className="text-[12px] font-bold" data-testid="medtrack-help-age">{ago}</span>
      </div>
    </div>
  );
};

export default HelpRequestBadge;
